import { render, staticRenderFns } from "./CampaignCredentials.vue?vue&type=template&id=2946d36e"
import script from "./CampaignCredentials.vue?vue&type=script&lang=js"
export * from "./CampaignCredentials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports